export type DateWindow =
  | {
      exactDeliveryDay?: number | null;
      minimumDeliveryDate?: number | null;
      maximumDeliveryDate?: number | null;
    }
  | null
  | undefined;

export const hasEstimatedDeliveryDate = (dateWindow: DateWindow) => {
  return (
    !!dateWindow?.exactDeliveryDay ||
    !!(dateWindow?.minimumDeliveryDate && dateWindow?.maximumDeliveryDate)
  );
};

export const hasEstimatedDeliveryDateDayOnly = (dateWindow: DateWindow) => {
  return (
    !!dateWindow?.exactDeliveryDay &&
    (!dateWindow?.minimumDeliveryDate || !dateWindow?.maximumDeliveryDate)
  );
};

export const hasEstimatedDeliveryDateWindowOnSameDay = (
  dateWindow: DateWindow,
) => {
  const minimumDate = new Date(dateWindow?.minimumDeliveryDate ?? 0);
  const maximumDate = new Date(dateWindow?.maximumDeliveryDate ?? 0);

  return (
    minimumDate.getFullYear() === maximumDate.getFullYear() &&
    minimumDate.getMonth() === maximumDate.getMonth() &&
    minimumDate.getDate() === maximumDate.getDate()
  );
};

export const hasIdenticalDeliveryTimes = (dateWindow: DateWindow) => {
  const minimumDate = new Date(dateWindow?.minimumDeliveryDate ?? 0);
  const maximumDate = new Date(dateWindow?.maximumDeliveryDate ?? 0);

  return (
    minimumDate.getHours() === maximumDate.getHours() &&
    minimumDate.getMinutes() === maximumDate.getMinutes()
  );
};
